import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-156a1cf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "savedShops" }
const _hoisted_2 = { class: "integral_head" }
const _hoisted_3 = { class: "head_bag" }
const _hoisted_4 = { class: "img_box" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "my_coins" }, "My Coins:", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = { class: "number" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "available" }, "coins available", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "right_arrow" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-right" })
], -1))
const _hoisted_11 = { class: "yellow_box" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "title_text" }
const _hoisted_14 = { class: "way" }
const _hoisted_15 = { class: "type mt-1" }
const _hoisted_16 = { class: "time mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_di = _resolveComponent("di")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { title: "My Coin Rewards" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("img", {
            src: 'https://image.kilimall.com/kenya/PcImages/gold.png'.webpFilters()

          }, null, 8, _hoisted_5)
        ]),
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString($setup.coins_total), 1),
        _hoisted_9,
        _hoisted_10
      ])
    ]),
    _createVNode(_component_van_tabs, {
      active: $setup.active,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (($setup.active) = $event)),
      onClick: $setup.onClick,
      "title-active-color": " linear-gradient(#FF582A,#FF2542)"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tab, { title: "AII History" }),
        _createVNode(_component_van_tab, { title: "Earning" }),
        _createVNode(_component_van_tab, { title: "Spending" })
      ]),
      _: 1
    }, 8, ["active", "onClick"]),
    _createVNode(_component_van_list, {
      loading: $setup.loading,
      "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => (($setup.loading) = $event)),
      finished: $setup.finished,
      "finished-text": "No more",
      "loading-text": "loading",
      onLoad: $setup.onLoad
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CoinsData.obj, (item1) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "renderer",
            key: item1.store_id
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("img", {
                src: 'https://image.kilimall.com/kenya/PcImages/yellow.png'.webpFilters()

              }, null, 8, _hoisted_12)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(item1.name), 1),
              _createElementVNode("span", _hoisted_15, _toDisplayString(item1.desc), 1),
              _createElementVNode("span", _hoisted_16, _toDisplayString(item1.time), 1)
            ]),
            _createVNode(_component_di, { class: "earn" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item1.amount >= 0 ? '+' + item1.amount : item1.amount), 1)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"])
  ]))
}